import { useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AnimatedCol from "../../../components/AnimatedCol.jsx";
import RenderFor, { BM_TYP } from "../../../components/RenderFor";
import { RowBody } from "../../../components/RowValue/RowBody.jsx";
import HiddenWrapperRow from "../../../components/UI/HiddenWrapperRow.jsx";
import MainArea from "../../../components/UI/MainArea.jsx";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../constants.js";
import { useGetTraggliedDatenQuery } from "../../../services/API/titanApi";
import { selectBelastungsartUndRichtung } from "../../../store/slices/belastungsartUndRichtungSlice.js";
import { selectBerechneInnere } from "../../../store/slices/innereSlice.js";
import {
  selectWerkstoffUebergangsrohr,
  setWerkstoffUebergangsrohr,
} from "../../../store/slices/pileHeadConstructionSlice.js";
import { selectTragglied } from "../../../store/slices/traggliedSlice.js";
import DesignLoad from "../Innere/DesignLoad.jsx";
import HollowBarDiameter from "../Innere/HollowBarDiameter.jsx";
import LoadType from "../Innere/LoadType.jsx";
import RequiredGroutCover from "../Innere/RequiredGroutCover.jsx";
import RequiredGroutCoverImage from "../Innere/RequiredGroutCoverImage.jsx";
import SelectedLoadCarryingElement from "../Innere/SelectedLoadCarryingElement.jsx";
import DruckHDPE from "./DruckHDPE";
import DruckStahl from "./DruckStahl";
import TransitionTubeMaterial from "./TransitionTubeMaterial.jsx";
import ZugHDPE from "./ZugHDPE";

export default function PileHeadConstruction() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const tragglied = useSelector(selectTragglied);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const belastungsartUndRichtung = useSelector(selectBelastungsartUndRichtung);

  if (belastungsartUndRichtung === ZUGPFAHL) dispatch(setWerkstoffUebergangsrohr(0));

  const druckMode = useSelector(selectWerkstoffUebergangsrohr, Object.is);
  const innereTragfaehigkeitsWerte = useSelector(selectBerechneInnere(traggliedDaten));

  const [showRequiredGroutCoverImage, setShowRequiredGroutCoverImage] = useState(false);

  return (
    <MainArea className="container">
      <div className="row">
        <br />
        <div className="col-md-8">
          <h1 className="mainheadline">{t("navigation.pileHeadConstruction")}</h1>
          <RenderFor types={[BM_TYP.GERMANY]}>
            <>
              <p>{t("aeussre.nationalTechnicalApprovalText")}</p>
              <br />
            </>
          </RenderFor>
          <p>{t("aeussre.additionalText")}</p>
        </div>
      </div>
      <br />
      <Row>
        <AnimatedCol>
          <LoadType readOnly={true} />
        </AnimatedCol>
        {belastungsartUndRichtung === DRUCKPFAHL ? (
          <AnimatedCol>
            <TransitionTubeMaterial />
          </AnimatedCol>
        ) : (
          <AnimatedCol>
            <RowBody
              titleValue={<p>{t("aeussre.transitionTubeMaterial")}</p>}
              inputValue={<span className="input">{t("aeussre.plasticTube")}</span>}
            />
          </AnimatedCol>
        )}

        <AnimatedCol>
          <DesignLoad readOnly={true} />
        </AnimatedCol>

        <AnimatedCol>
          <SelectedLoadCarryingElement readOnly={true} />
        </AnimatedCol>

        <AnimatedCol>
          <HollowBarDiameter duchmesserTragglied={traggliedDaten?.durchmesser} />
        </AnimatedCol>

        <AnimatedCol>
          <RequiredGroutCover
            erforderlicheZementsteinueberdeckung={innereTragfaehigkeitsWerte?.Csol}
            showModal={setShowRequiredGroutCoverImage}
          />
        </AnimatedCol>

        <RenderFor types={[BM_TYP.EUROCODE_7]}>
          <HiddenWrapperRow>
            <RequiredGroutCoverImage
              show={showRequiredGroutCoverImage}
              setShow={setShowRequiredGroutCoverImage}
            />
          </HiddenWrapperRow>
        </RenderFor>
      </Row>
      {belastungsartUndRichtung === DRUCKPFAHL ? (
        <>
          {druckMode == 0 ? <DruckHDPE /> : null}
          {druckMode == 1 ? <DruckStahl /> : null}
        </>
      ) : null}
      {belastungsartUndRichtung === ZUGPFAHL ? <ZugHDPE /> : null}
    </MainArea>
  );
}
